import React, { useEffect, useState, useRef, useCallback } from "react";
import { MapContainer, TileLayer, GeoJSON, LayersControl,ScaleControl } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./TsunamiThreat.css";
import { FaCircleInfo } from "react-icons/fa6";
import { MapHomeControl } from "../../../common/MapControls/MapControls";

const INITIAL_VIEW_STATE = {
    longitude: 125.7275,
    latitude: -8.8742,
    zoom: 8,
};
const InfoButton = ({ onClick }) => {
    // Leaflet's own drag/click handling swallows clicks on overlay controls
    // unless propagation to the map is explicitly disabled on the DOM node.
    const btnRef = useCallback((node) => {
      if (node) {
        L.DomEvent.disableClickPropagation(node);
        L.DomEvent.disableScrollPropagation(node);
      }
    }, []);
    return (
      <div
        ref={btnRef}
        style={{
          position: "absolute",
          bottom: "20px",
          left: "12px",
          padding: "8px",
          borderRadius: "8px",
          fontSize: "15px",
          //boxShadow: "0 0 6px rgba(0,0,0,0.3)",
          cursor: "pointer",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px) brightness(1.1)",
        WebkitBackdropFilter: "blur(10px) brightness(1.1)",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        color: "#333333",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        transition: "all 0.2s ease",
          zIndex: 1000,
        }}
        onClick={onClick}
      >
        <FaCircleInfo/>
      </div>
    );
};
const TsunamiThreat = () => {
  const [boundaryData, setBoundaryData] = useState(null);
const [info, setInfo] = useState(false);
  const infoRef = useRef(null);
  const infoPanelRef = useCallback((node) => {
    infoRef.current = node;
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  useEffect(() => {
    if (!info) return;
    const handleClickOutside = (e) => {
      if (infoRef.current && !infoRef.current.contains(e.target)) setInfo(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [info]);

  useEffect(() => {
    // Load the GeoJSON boundary data
    fetch("/DATA/OSMbased_adm1_boundary.json")
      .then((response) => response.json())
      .then((data) => setBoundaryData(data))
      .catch((error) => console.error("Error loading boundary data:", error));
  }, []);

    // Scenarios - Start
        const [scenA, setScenA] = useState(null);
        const [scenB, setScenB] = useState(null);
        const [scenC, setScenC] = useState(null);
        const [scenD, setScenD] = useState(null);
        useEffect(() => {
            fetch("/Earthquake/scenario_A.geojson")
            .then((response) => response.json())
            .then((data) => setScenA(data))
            .catch((error) => console.error("Error loading slab depth data:", error));
        }, []);

        useEffect(() => {
            fetch("/Earthquake/scenario_B.geojson")
            .then((response) => response.json())
            .then((data) => setScenB(data))
            .catch((error) => console.error("Error loading slab depth data:", error));
        }, []);

        useEffect(() => {
            fetch("/Earthquake/scenario_C.geojson")
            .then((response) => response.json())
            .then((data) => setScenC(data))
            .catch((error) => console.error("Error loading slab depth data:", error));
        }, []);

        useEffect(() => {
            fetch("/Earthquake/scenario_D.geojson")
            .then((response) => response.json())
            .then((data) => setScenD(data))
            .catch((error) => console.error("Error loading slab depth data:", error));
        }, []);
    // Scenarios - End

   
const Legend = () => {
    return (
        <div className="flood-hyd-station-icon forecast-legend">
            {/* <div><i style={{ background:"#8d5a99", opacity : "0.8" }}></i> Land Cover</div>
            <div><i style={{ background:"brown", opacity : "0.8" }}></i> Soil Texture</div>
            <div><h5>Deficiency Risk Hollow</h5></div>
            <div><i style={{ background:"Green", opacity : "0.8" }}></i> Low Risk</div>
            <div><i style={{ background:"Yellow", opacity : "0.8" }}></i> Medium Risk</div>
            <div><i style={{ background:"Red", opacity : "0.8" }}></i> High Risk</div> */}
        </div>
    );
};

  return (
    <div className="wind-speed-cyclone-container">
      <div className="map-container-WindSpeedCyclone">
        <MapContainer
          center={[INITIAL_VIEW_STATE.latitude, INITIAL_VIEW_STATE.longitude]}
          attributionControl={false}
          zoom={INITIAL_VIEW_STATE.zoom}
          style={{ width: "100%", height: "650px" }}
        >
          <MapHomeControl />
        {info && (
            <div
            ref={infoPanelRef}
            style={{
                position: "absolute",
                bottom: "70px",
                left: "12px",
                fontSize: "12px",
                zIndex: 1000,
                padding: "10px 14px",
                borderRadius: "10px",
                background: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(10px) brightness(1.1)",
                WebkitBackdropFilter: "blur(10px) brightness(1.1)",
                border: "1px solid rgba(0, 0, 0, 0.08)",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.5)",
                color: "#333333",
                fontWeight: "500",
                maxWidth: "320px",
                lineHeight: "1.4",
              }}
            >
            Source : Timor - Leste
            </div>
        )}
        <InfoButton onClick={() => setInfo(!info)} />
          {/* Layer toggle control */}
            <LayersControl position="topright">
                <LayersControl.BaseLayer name="White Theme" checked>
                    <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                </LayersControl.BaseLayer>
                Scenarios
                <LayersControl.Overlay name="Scenario A" checked >
                    {scenA && (
                    <GeoJSON
                        data={scenA}
                    />
                    )}
                </LayersControl.Overlay>
                <LayersControl.Overlay name="Scenario B" checked >
                    {scenB && (
                    <GeoJSON
                        data={scenB}
                    />
                    )}
                </LayersControl.Overlay>
                <LayersControl.Overlay name="Scenario C" checked>
                    {scenC && (
                    <GeoJSON
                        data={scenC}
                    />
                    )}
                </LayersControl.Overlay>
                <LayersControl.Overlay name="Scenario D" checked>
                    {scenD && (
                    <GeoJSON
                        data={scenD}
                    />
                    )}
                </LayersControl.Overlay>
                
            </LayersControl>

            {/* Render the boundary GeoJSON layer if data is loaded */}
            {boundaryData && (
                <GeoJSON
                    data={boundaryData}
                    style={{
                        color: "#000000",
                        weight: 1,
                        opacity: 0.8,
                        dashArray: 6,
                        fillOpacity: 0,
                    }}
                />
            )}
            <ScaleControl position="bottomleft"/>
            <Legend position="bottomright" />
        </MapContainer>
      </div>
    </div>
  );
};

export default TsunamiThreat;
